import React, { useState, useEffect } from 'react';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';

import $ from 'jquery';
import mainURL from '../../config/environment';

const useProviders = (refresh) => {
  const [providers, setProviders] = useState([]);
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('userInfo')).token;
    let isSubscribed = true;
    $.ajax({
      method: 'GET',
      url: mainURL + 'provider/get-all',
      contentType: 'application/json',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }).done((res) => {
      if (isSubscribed) setProviders(res);
    });
    return () => (isSubscribed = false);
  }, []);
  return providers;
};

export default function SelectProvider(props) {
  const { handleChange } = props;
  const { required } = props;
  const { refresh } = props;
  const { value } = props;
  const { name } = props;

  const providers = useProviders(refresh);

  return (
    <FormControl fullWidth required={required} sx={{ height: '56px', justifyContent: 'flex-end' }}>
      <InputLabel variant="standard">{'Proveedor'}</InputLabel>
      <Select value={value} onChange={handleChange} name={name} variant="standard" native>
        <option value="" />
        {providers.map((provider) => (
          <option key={provider.id} value={provider.id}>
            {provider.name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
}
